import { ApiError } from '~/shared/api/http-client';

export const refusalMessage = (err: unknown, fallback: string): string => {
  if (!(err instanceof ApiError)) return fallback;
  switch (err.code) {
    case 'Auth.OtpRateLimit':
      return 'Код уже отправлен. Запросить новый можно через минуту.';
    case 'Auth.SmsDailyCapReached':
      return 'Отправка кодов временно приостановлена. Попробуйте позже.';
    case 'Auth.OtpDeliveryFailed':
      return 'Не удалось доставить SMS. Попробуйте ещё раз чуть позже.';
    case 'Auth.InvalidOtp':
      return 'Неверный или устаревший код. Запросите новый и введите код из последней SMS.';
    case 'Auth.OtpMaxAttempts':
      return 'Слишком много неверных попыток. Запросите новый код.';
    default:
      return err.message;
  }
};

export const maskPhone = (phone: string): string => {
  const digits = phone.replace(/\D/g, '');
  return digits.length < 4 ? 'номер в профиле' : `··· ${digits.slice(-4)}`;
};
